module.exports = __webpack_public_path__ + "media/images/donations/dinersclub-3f7f501fc46080a48b68a2610b18e9eb.png";